
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"3","height":"7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.938.313c.286 0 .523.101.71.304.193.198.29.45.29.758 0 .307-.097.563-.29.766a.937.937 0 01-.71.296.963.963 0 01-.72-.296 1.085 1.085 0 01-.28-.766c0-.307.093-.56.28-.758a.95.95 0 01.72-.304zm0 4.101c.286 0 .523.102.71.305.193.198.29.45.29.758 0 .307-.097.562-.29.765a.937.937 0 01-.71.297.963.963 0 01-.72-.297 1.085 1.085 0 01-.28-.765c0-.308.093-.56.28-.758a.95.95 0 01.72-.305z","fill":"currentColor"}})])
          )
        }
      }
    